<template>
  <div class="tw-max-h-full">
    <GraphqlDataTable
      :query
      :order-by="initialOrder"
      :filter-black-list="['accounts']"
      :quick-filters="['jobOwners']"
      :max-height-adjustment="60"
      @full-screen="fullscreen = $event"
    >
      <template #action="{ row }">
        <JobActionColumn :row="row" />
      </template>
    </GraphqlDataTable>
  </div>
</template>

<script lang="ts" setup>
import { TypedQueryDocumentNode } from 'graphql/index'
import { ref } from 'vue'
import GraphqlDataTable from '@/components/GraphqlDataTable/GraphqlDataTable.vue'
import { graphql } from '@/gql'
import JobActionColumn from '@/components/GraphqlDataTable/columns/Job/JobActionColumn.vue'
import { JobOrderByColumn, SortOrder } from '@/gql/graphql'

const fullscreen = ref(false)

const query = graphql(`
  query JobsContractsQuery(
    $accounts: [ID!]
    $search: String
    $page: Int!
    $first: Int!
    $orderBy: [JobsOrderByClauseInput!]
    $jobOwners: [ID!]
    $hasBids: Boolean
    $hasHire: Boolean
    $startDateRange: DateRangeInput
    $endDateRange: DateRangeInput
    $rateTypes: [RateType!]
    $locationPreferences: [LocationPreference!]
    $commitment: [Association!]
    $skills: [String!]
    $seniority: [ExpectedExperienceLevel!]
    $customFields: [CustomFieldTypeValueInput!]
  ) {
    jobs(
      accounts: $accounts
      search: $search
      page: $page
      first: $first
      hasBids: $hasBids
      hasHire: $hasHire
      rateTypes: $rateTypes
      associations: $commitment
      locationPreferences: $locationPreferences
      owners: $jobOwners
      skills: $skills
      experienceLevel: $seniority
      orderBy: $orderBy
      customFields: $customFields
      startDateRange: $startDateRange
      endDateRange: $endDateRange
    ) {
      paginatorInfo {
        ...PaginatorInfoFragment
      }
      data {
        ...JobCreatedAtColumn
        ...JobSharedChannelsColumn
        ...JobHireAndPoNumberColumn
        ...JobStartDateColumn
        ...JobEndDateColumn
        ...JobCandidatesBidsHiresColumn
        ...RateColumnJob
        ...JobOwnersColumn
      }
    }
  }
`) as TypedQueryDocumentNode

const initialOrder = {
  field: JobOrderByColumn.CreatedAt,
  order: SortOrder.Desc,
}
</script>
